import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import * as ES from '../locales/es/index';
import * as EN from '../locales/en/index';

const resources = {
  en: { translation: Object.assign({}, ...Object.values(EN)) },
  es: { translation: Object.assign({}, ...Object.values(ES)) }
};

const i18nResources = resources;

const currentUrl = window.location.search;
const urlParams = new URLSearchParams(currentUrl);
const lang = urlParams.get('locale') ?? SessionData.user.lang ?? 'es';

//--> need recompile comment
//--> need recompile comment
//--> need recompile comment

i18n.use(initReactI18next).init({
  resources: i18nResources,
  fallbackLng: SessionData.user.lang,
  defaultLanguage: 'en',
  lng: lang,
  languages: ['es', 'en'],
  interpolation: {
    escapeValue: false
  },
  // debug: !SessionData.isp.production,
  react: {
    wait: true
  }
});

export default i18n;
